import React, { useState } from 'react'
import { storage } from "./../../../base";
import moment from "moment";
import { Form, ProgressBar,Spinner } from "react-bootstrap"
import { useDispatch, useSelector } from 'react-redux';
import axios from "axios"
import { URL } from '../../../redux/actions/types';
import { fetchAllCustomer } from "../../../redux/actions/customerActions"

const CustomerAdd = () => {

    let dispatch = useDispatch()
    // Total files
    const [accHolderIdCard, setAccHolderIdCard] = useState(null)
    const [signatureCard, setSignatureCard] = useState(null)
    const [photoId, setPhotoId] = useState(null)
    const [nomineeIdCard, setNomineeIdCard] = useState(null)
    const [fullname, setFullname] = useState("");
    const [accountNumber, setAccountNumber] = useState("");
    const [Phone, setPhone] = useState("")

    const [uploading, setUploading] = useState(false)
    const [prograse, setPrograse] = useState(0)
    const [submitting, setSubmitting] = useState(false)
    // take userid from redux
    let userid =  useSelector(state => state.auth.userid)

    const [hasFormError, setHasFormError] = useState(false)
    const [formErrorMsg, setFormErrorMsg] = useState("")


    const [isSuccess, setisSuccess] = useState(false);
    const [successMsg, setSuccessMsg] = useState("")

    const submit = async () => {

        // Condition for Rendaring
        if(fullname===""){
            setHasFormError(true)
            setFormErrorMsg("Name must not me Empty !")
        }else if(Phone.split("").length > 11 ||  Phone.split("").length < 11){
            setHasFormError(true)
            setFormErrorMsg("Phone number must be 11 digit !")
        }else{
            let info = {
                userid,
                accHolderIdCard,
                signatureCard,
                photoId,
                nomineeIdCard,
                fullname,
                accountNumber,
                Phone
            }
    
            
            setSubmitting(true)
            const { data }  = await axios.post(`${URL}customer/add`, info)
            setSubmitting(false)
            if(data.success){
                setisSuccess(true)
                setSuccessMsg("customer add successfully !")
                setHasFormError(false)
                // Reset image Feild
                setAccHolderIdCard(null)
                setSignatureCard(null)
                setPhotoId(null)
                setNomineeIdCard(null)
                setFullname("")
                setAccountNumber("")
                setPhone("")

                dispatch(fetchAllCustomer(userid))

            }else{
                setHasFormError(true)
                setFormErrorMsg(data.error)
                setisSuccess(false)
            }
        }
    }

    const handleUpload = (file, filename,  settar) => {
       const upload =  storage.ref(`${userid}/${filename}`).put(file)
       upload.on('state_changed', snapshot => {
           const prograse = Math.round(
               (snapshot.bytesTransferred / snapshot.totalBytes) * 100
           )
           setPrograse(prograse)
       }, error => {
           console.log(error)
       }, () => {
           storage.ref(userid)
           .child(filename)
           .getDownloadURL()
           .then(url => {
               setUploading(false)
               setPrograse(0)
                settar(url)
           })
       })
    }

    return (
        <div>
            <div className="col-md-6 mx-auto">

                <div className="card">
                    <div className="card-header">
                        <h3>Add customer</h3>
                    </div>
                    {uploading && 
                    <div>
                        <ProgressBar striped variant="success" now={prograse} />
                    </div>}
                    

                    <div className="card-body">
                    

                    {hasFormError && <div className="alert alert-danger"><strong>Error: </strong> {formErrorMsg}</div>}
                    {isSuccess && <div className="alert alert-success"><strong>Success : </strong>{successMsg}</div>}
                    
                        <div className="form-group">
                            <label htmlFor="name">Full name</label>
                            <Form.Control value={fullname} onInput={(e)=> setFullname(e.target.value)} className="form-control" disabled={uploading} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="name">Account Number</label>
                            <Form.Control value={accountNumber} onInput={(e)=> setAccountNumber(e.target.value)} className="form-control" disabled={uploading} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="name">Phone</label>
                            <Form.Control value={Phone} onInput={(e)=> setPhone(e.target.value)} className="form-control" disabled={uploading} />
                        </div>

                        <div className="form-group">
                            <label htmlFor="name">Account Holder ID Card</label>
                            <Form.File 
                                disabled={uploading}
                                id="custom-file"
                                label={accHolderIdCard?"Upload Done":"Select Account Holder image"}
                                custom
                                onChange={(e) => {
                                    let file = e.target.files[0];
                                    let filename = moment.now()+"."+file.name.substring(file.name.lastIndexOf('.')+1, file.name.length) || file.name;
                                    // Enable Loading
                                    setUploading(true)
                                    handleUpload(file, filename, setAccHolderIdCard)
                                }}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="name">Signature Card</label>
                            <Form.File 
                                disabled={uploading}
                                id="custom-file"
                                label= {signatureCard?"Upload Done":"Select signature card"}
                                custom
                                onChange={(e) => {
                                    let file = e.target.files[0];
                                    let filename = moment.now()+"."+file.name.substring(file.name.lastIndexOf('.')+1, file.name.length) || file.name;
                                    // Enable Loading
                                    setUploading(true)
                                    handleUpload(file, filename, setSignatureCard)
                                }}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="name">Photo ID</label>
                            <Form.File 
                                disabled={uploading}
                                id="custom-file"
                                label={photoId?"Upload Done":"Select Photo ID"}
                                custom
                                onChange={(e) => {
                                    let file = e.target.files[0];
                                    let filename = moment.now()+"."+file.name.substring(file.name.lastIndexOf('.')+1, file.name.length) || file.name;
                                    // Enable Loading
                                    setUploading(true)
                                    handleUpload(file, filename, setPhotoId)
                                }}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="name">ID Card (Nominee)</label>
                            <Form.File 
                                disabled={uploading}
                                id="custom-file"
                                label={nomineeIdCard?"Upload Done":"Select Nominee ID Card"}
                                custom
                                onChange={(e) => {
                                    let file = e.target.files[0];
                                    let filename = moment.now()+"."+file.name.substring(file.name.lastIndexOf('.')+1, file.name.length) || file.name;
                                    // Enable Loading
                                    setUploading(true)
                                    handleUpload(file, filename, setNomineeIdCard)
                                }}
                            />
                        </div>
                        <div className="form-group">
                            <button disabled={uploading || submitting} onClick={submit} className="btn btn-dark btn-block">
                                {submitting? <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                />:"Add Customer"}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CustomerAdd
